<div class="overview-container">
  <!-- Filters -->
  <div class="d-flex align-items-end gap-3 mb-3 flex-wrap">
    <div>
      <label class="form-label small mb-1">{{ 'contracts.filterMonth' | translate }}</label>
      <input type="month" class="form-control form-control-sm" [(ngModel)]="selectedMonth" (ngModelChange)="applyFilters()">
    </div>
    <div>
      <label class="form-label small mb-1">{{ 'contracts.filterTaskStatus' | translate }}</label>
      <select class="form-select form-select-sm" [(ngModel)]="selectedStatus" (ngModelChange)="applyFilters()">
        @for (opt of statusOptions; track opt.value) {
          <option [value]="opt.value">{{ opt.labelKey | translate }}</option>
        }
      </select>
    </div>
    <div>
      <label class="form-label small mb-1">{{ 'contracts.filterContractStatus' | translate }}</label>
      <select class="form-select form-select-sm" [(ngModel)]="selectedActive" (ngModelChange)="applyFilters()">
        <option value="all">{{ 'contracts.filterAll' | translate }}</option>
        <option value="active">{{ 'contracts.filterActive' | translate }}</option>
        <option value="previous">{{ 'contracts.filterPrevious' | translate }}</option>
      </select>
    </div>
    <button class="btn btn-outline-secondary btn-sm" (click)="clearFilters()">
      {{ 'contracts.clearFilters' | translate }}
    </button>
  </div>

  <!-- Column Visibility Controls -->
  <div class="column-controls">
    <button class="btn btn-primary toggle-btn mb-1" (click)="toggleColumnPanel()">
      {{ showColumnPanel ? ("labels.hideColumnOptions" | translate) : ("labels.showColumnOptions" | translate) }}
    </button>

    @if(showColumnPanel) {
    <div class="column-panel">
         <div class="bulk-actions">
          <button class="bulk-btn" (click)="showAllColumns()">{{"contracts.buttons.showAll" | translate}}</button>
          <button class="bulk-btn" (click)="hideAllColumns()">{{"contracts.buttons.hideAll" | translate}}</button>
        </div>

      <div class="column-list">

        @for(column of columnVisibility; track column.field ) {
        <label class="column-item">
          <input type="checkbox" [checked]="column.visible" [disabled]="column.field === 'taskSmall.title' || column.field === 'actions'" (change)="toggleColumnVisibility(column.field)" />
          <span>{{ column.headerName }}</span>

        </label>
        }

      </div>
    </div>
    }

  </div>

  <!-- The AG Grid component -->
  <ag-grid-angular
    style="width: 100%; height: 100%;"
    [rowData]="filteredContractList"
    [columnDefs]="colDefs"
    [defaultColDef]="defaultColDef"
    [context]="gridContext"
    [pagination]="true"
    (gridReady)="onGridReady($event)"
    (rowDoubleClicked)="onRowClicked($event)"
    [suppressNoRowsOverlay]="true"
  />

  <router-outlet></router-outlet>
</div>